module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Get Paid More and Promoted Faster")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "CSS_1.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "d14e203"
    }
  }, [_c('h1', {
    attrs: {
      "id": "d7e35710"
    }
  }, [_vm._v("Preface ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "d7e36210"
    }
  }, [_c('br'), _c('b', [_vm._v("T")]), _vm._v("his book is for anyone who wants to take full control over his or her career. If you feel that you are deserving of far more than you are receiving today, you are probably right. This book will show you how to get it. The twenty-one ideas you are about to learn will give you a series of practical, proven techniques that you can implement immediately to move upward and onward more rapidly in any company or job.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "d7e39310"
    }
  }, [_vm._v("These strategies have been distilled and condensed from my more than thirty years of experience in the world of work, at every level, from the most menial job all the way up to the executive suite. I started as a dishwasher and then was a stock boy in a department store. I worked my way through more than twenty different jobs in varying industries and different countries, learning these principles the hard way as I struggled forward.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "d7e42510"
    }
  }, [_vm._v("Throughout my career, I was continually looking around me and asking, “Why is it that some people are more successful than others?” Specifically, why  do some people get paid more and promoted faster at work and others not?")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "d7e44911"
    }
  }, [_vm._v("Over the years, I rose from laboring jobs through sales and into management, eventually becoming the chief operating officer of a $265 million company. Today, I consult with the executives of some of the biggest companies in the world on the subjects of career development and personal success.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "d7e47411"
    }
  }, [_vm._v("In my various positions, I have hired, trained, advised, appraised, promoted, and fired countless people, from junior staff up to company presidents. I have designed and conducted seminars for thousands of ambitious men and women who wanted to get ahead more rapidly.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "d7e49711"
    }
  }, [_vm._v("In my advanced personal coaching programs, I work with successful executives and entrepreneurs to help them to strategize and reorganize themselves to do more of the right things, in the right way, so they can increase their incomes at a faster rate than ever before.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "d7e51511"
    }
  }, [_vm._v("These ideas apply to you, whatever you are doing today. The fact is that you are probably worth twice as much as you are earning right now. You may be worth five or ten times as much. But it is completely up to you to take the necessary actions to maximize your potential at work.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "d7e53811"
    }
  }, [_vm._v("You are in charge. You are the architect of your own career. You largely determine everything that happens to you, especially in the long term. Your chief  responsibility to yourself in your work is to increase your ROE, your “return on energy.” Your main goal should be to get the highest return on the part of your life that you invest in your job. Your aim should be to get paid the very most possible for the amount of time you spend.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "d7e57912"
    }
  }, [_vm._v("It takes just as many years to be a big success in your field as to be average. And the truth is that you are not average. You probably have the capacity to be extraordinary in some way, and possibly in many ways. You almost certainly have within you, at this very moment, untapped talents and abilities that you have never fully utilized. Your job is to identify your special talents and then to apply them to getting the very most out of yourself and your career.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "d7e61112"
    }
  }, [_vm._v("This book has one single focus: career success. It is not about balance, quality of life, or the importance of personal relationships. These vital subjects are better dealt with in another place.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "d7e62712"
    }
  }, [_vm._v("The twenty-one great ideas in this book are aimed solely at helping you fulfill your desire to do as well as you possibly can in your chosen field. These principles are based on the fact that you are in charge of your own career and your own future. You are not a passive agent waiting and hoping for good things to happen to you. Rather, you are the primary creative force in your own life. You are a creator of circumstances, not simply a creature of circumstance.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "d7e66213"
    }
  }, [_vm._v("Every idea, method, strategy, and technique you are about to learn has been tested and proven in the crucible of practical experience. Thousands of men and women are applying these principles every day to dramatically improve their results at work. Regular use of these “twenty-one great ways” will save you years of hard work in reaching the same level of income and success. And there are no real limits on what you can accomplish except for the limits you place on yourself.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "d7e69713"
    }
  }, [_c('span', {
    attrs: {
      "id": "d14e236"
    }
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIAN")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RACY")]), _c('br'), _c('i', [_vm._v("Solana Beach, California ")]), _c('br'), _c('i', [_vm._v("April 2001 ")])])]), _vm._v(" "), _c('p', [_c('br'), _c('br'), _c('br'), _c('br'), _c('br')])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-901b70ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Preface.vue
// module id = 72
// module chunks = 0